import { connect } from 'react-redux'
import ReportingConfig from './ReportingConfig.component'
import * as Actions from 'state/actions'

const mapStateToProps = state => {
  return {
    isFetchingConfig: state.analyticsExport.isFetchingConfig,
    isSavingConfig: state.analyticsExport.isSavingConfig,
    reportingConfig: state.analyticsExport.reportingConfig,
    agentId: state.agent?.active?.agentId
  }
}

const mapDispatchToProps = dispatch => {
  return {
    updateReportingConfig: key => e => dispatch(Actions.updateReportingConfig(key, e.target.value)),
    fetchReportingConfig: () => dispatch(Actions.fetchReportingConfig())
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReportingConfig)
